import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SetSelector from "./ThemeEditor/SetSelector";
import ColorApp from "./ThemeEditor/color/ColorApp";
import TypographyApp from "./ThemeEditor/typography/TypographyApp";
import LayoutApp from "./ThemeEditor/layout/LayoutApp";
import AestheticsApp from "./ThemeEditor/aesthetics/AestheticsApp";
import AssetsApp from "./ThemeEditor/assets-ui/AssetsApp";
import FormApp from "./ThemeEditor/forms/FormApp";
import { ClientStore } from "../contexts/ClientContext";
import AppHeader from "./AppHeader";
import ClientPicker from "./ClientPicker";
import ThemeEditor from "./ThemeEditor/ThemeEditor";

const AuthenticatedApp = () => {
  return (
    <ClientStore>
      <BrowserRouter>
        <AppHeader />
        <Routes>
          <Route exact path="/" element={<ClientPicker />} />
          <Route exact path="/themeeditor/:clientid" element={<ThemeEditor />}>
            <Route
              exact
              path="/themeeditor/:clientid/color"
              element={<SetSelector app="Color" />}
            />
            <Route exact path="/themeeditor/:clientid/color/:setid" element={<ColorApp />} />
            <Route exact path="/themeeditor/:clientid/typography/*" element={<TypographyApp />} />
            <Route exact path="/themeeditor/:clientid/layout" element={<LayoutApp />} />
            <Route exact path="/themeeditor/:clientid/aesthetics" element={<AestheticsApp />} />
            <Route exact path="/themeeditor/:clientid/assets" element={<AssetsApp />} />
            <Route exact path="/themeeditor/:clientid/forms" element={<FormApp />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ClientStore>
  );
};

export default AuthenticatedApp;
